import { FunctionComponent, useEffect } from 'react';
import { Box, chooseColor } from 'vopay';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../providers/Layout.provider';
import { useToken } from '../../providers/Token.provider';
import { usePaylink } from '../../providers/Paylink.provider';
import PageTitle from '../UI/PageTitle';
import OTPForm from './OTPForm';
import styles from './OTP.module.scss';

const OTPContainer: FunctionComponent = () => {
  const { setLayoutInfo } = useLayout();
  const { token, isSetByBrowser } = useToken();
  const { paylink } = usePaylink();
  const { t } = useTranslation('translations', { keyPrefix: 'OTP' });

  useEffect(() => {
    setLayoutInfo(
      chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      70,
      32,
      0,
      !isSetByBrowser,
      true,
    );
  }, []);

  return (
    <Box flx="col" gapSize="24px" height="auto" minheight="80vh" ai="center" jc="center">
      <PageTitle title={t('title')} size="lg" bold />
      <p className={styles.description}>
        {t('description')}
        <span className={styles.phoneNumber}>{formatPhoneNumber(paylink.ReceiverPhoneNumber || '')}</span>.
      </p>
      <OTPForm />
    </Box>
  );

  function formatPhoneNumber(phone: string) {
    let phoneNumber = phone;

    if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
      phoneNumber = phoneNumber.slice(1);
    }

    const areaCode = phoneNumber.slice(0, 3);
    const firstPart = phoneNumber.slice(3, 6);
    const secondPart = phoneNumber.slice(6);

    return `+1(${areaCode}) ${firstPart}-${secondPart}`;
  }
};

export default OTPContainer;
